export const profilePagesRouterMatches = () => ({
    user_area: /^\/?(?:travel\/)?profile\/user_area\/(.*)/,
    login_and_security: /^\/?(?:travel\/)?profile\/login_and_security\/(.*)/,
    reset_password: /^\/?(?:travel\/)?profile\/reset_password\/(.*)/,
    payment_methods: /^\/?(?:travel\/)?profile\/payment_methods\/(.*)/,
});

export const profilePagesAppChangePages = () => ({
    secure: {
        user_area: 'profile',
        login_and_security: 'profile',
        reset_password: 'profile',
        payment_methods: 'profile',
    },
    profilepages: {
        user_area: 'userarea',
        login_and_security: 'loginandsecurity',
        reset_password: 'resetpassword',
        payment_methods: 'paymentmethods',
    },
});

export const profilePagesSecurePages = () => ({
    user_area: 'profile',
    login_and_security: 'profile',
    reset_password: 'profile',
    payment_methods: 'profile',
});
